import React from 'react';
import { Link } from 'react-router-dom'
import '../menu.css';

export default function Menu({ menu_items, tag_items, symbol_items, recent_items, selected_menu, onPageSelected, onLogout }) {

    const sectionStyle = {

        "background": 'hsl(0, 0%, 4%)',
        "color": "hsl(0, 0%, 100%)",
        "height": "100%"
    };

    const menuStyle = {

        "color": "hsl(0, 0%, 100%)"
    };

    return (
        <div className="ss-container-stacked is-dark" style={sectionStyle} id="ss-app-menu">
            <nav className="navbar is-black" style={{ height: "71px" }}>
                <div class="navbar-brand">
                    <div class="navbar-item">
                        <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                    </div>
                    <div className="navbar-item ss-menu-detail-text">
                        <div>
                            <p className="title is-4 has-text-white">Stock-Sheet</p>
                        </div>
                    </div>
                </div>
                {/* <div class="navbar-end">
                    <div class="navbar-item">
                        <p class="control">
                            <a class="button is-black has-text-danger">
                                <span class="icon">
                                    <i class="fa fa-close"></i>
                                </span>
                            </a>
                        </p>
                    </div>
                </div> */}
            </nav>
            <div className=" ss-fluid-row">
                <hr style={{ marginTop: 0, backgroundColor: "hsl(0, 0%, 21%)" }} ></hr>
                <aside className="menu ss-dark-menu">
                    <ul className="menu-list">
                        {console.log(menu_items)}
                        {menu_items.map(function (item) {

                            return <li>
                                <Link to={item.link}
                                    style={menuStyle} className={selected_menu === item.link ? "is-active" : ""}>
                                    <i className={item.icon} aria-hidden="true" style={{ marginRight: "0.75em" }} onClick={onPageSelected}></i>
                                    <span> {item.name}</span>
                                </Link>
                            </li>
                        })}
                    </ul>
                    {tag_items && tag_items.length > 0 && (
                        <div>
                            <hr style={{ backgroundColor: "hsl(0, 0%, 21%)" }}></hr>
                            <ul className="menu-list">
                                {tag_items.map(function (item) {

                                    return <li><a style={menuStyle}><i className="fa fa-hashtag" aria-hidden="true" style={{ marginRight: "0.75em" }} onClick={onPageSelected}></i>{item.name}</a></li>
                                })}
                            </ul></div>)}
                    {symbol_items && symbol_items.length > 0 && (
                        <div>
                            <hr style={{ backgroundColor: "hsl(0, 0%, 21%)", marginBottom: 0 }}></hr>
                            <p class="menu-label" style={{ paddingLeft: "12px" }}>
                                Open
                                    </p>
                            <ul className="menu-list">
                                {symbol_items.map(function (position_item) {

                                    let link_url = "/symbol/" + position_item.symbol;
                                    return <li>
                                        <Link to={link_url} style={menuStyle} className={selected_menu === link_url ? "is-active" : ""}>
                                            <i className={"fa fa-circle " + (position_item.unrealized_gains > 0 ? "has-text-success" : "has-text-danger")} aria-hidden="true" style={{ marginRight: "0.75em" }}></i>{position_item.symbol}
                                            <span className={"is-pulled-right ss-menu-detail-text " + (position_item.unrealized_gains > 0 ? " has-text-success" : " has-text-danger")}>
                                                ${position_item.unrealized_gains.toFixed(2)}
                                            </span>
                                        </Link>
                                    </li>
                                })}
                            </ul>
                            {recent_items != null && recent_items.length > 0 &&
                                <div>
                                    <p class="menu-label" style={{ paddingLeft: "12px" }}>
                                        Recent
                                    </p>
                                    <ul className="menu-list">
                                        {recent_items.map(function (symbol) {

                                            let link_url = "/symbol/" + symbol;
                                            return <li>
                                                <Link to={"/symbol/" + symbol} style={menuStyle} className={selected_menu === link_url ? "is-active" : ""}>
                                                    <i className="fa fa-circle has-text-info" aria-hidden="true" style={{ marginRight: "0.75em" }}></i>{symbol}

                                                    <span className="is-pulled-right has-text-info ss-menu-detail-text">-</span>
                                                </Link>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                            }

                        </div>)
                    }
                </aside>
            </div>
            <div className="ss-fixed-row">
                <div class="notification is-black is-size-7" style={{ margin: "2px", textAlign: "center", padding: "2px" }} id="iex-promo-use">
                    Data provided for free by <a target="_blank" href="https://iextrading.com/developer">IEX</a>.
                </div>
                <hr style={{ backgroundColor: "hsl(0, 0%, 21%)", margin: 0 }}></hr>
                <div>

                    <a class="button is-black" style={{ width: "100%" }} onClick={() => onLogout()} >
                        <span class="icon is-small">
                            <i class="fa fa-sign-out"></i>
                        </span>
                        <span class='ss-menu-detail-text'> Sign out </span></a>
                </div>

            </div>

        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/menu.js